import apiClient from './client';

/**
 * Country/Country-code helper APIs
 */
export const countriesApi = {
  // Backend route: router.get("/api/users/countries", verifyToken, usersController.getCountries);
  // Use path without the leading /api so client can prepend the configured API_PREFIX (/api/v1.0, /api, etc.).
  getCountryCodes: () => apiClient.get('/users/countries'),
};

export default countriesApi;
